import type { HTMLAttributes } from 'react';
import type { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import type { MListTextIconProps } from '../MListTextIcon/MListTextIcon.types';
import { MListTextIconSize } from '../MListTextIcon/MListTextIcon.types';

export { MListTextIconSize as MListTextGroupVerticalSize };

type MListTextGroupVerticalSize = MListTextIconSize;

export interface MListTextGroupVerticalProps extends HTMLAttributes<HTMLDivElement> {
  /** Size variant for all list items. Defaults to Medium. */
  size?: MListTextGroupVerticalSize;
  showSubheader?: boolean;
  aSubheader?: ASubheaderProps;
  items?: MListTextIconProps[];
}
